import { render, staticRenderFns } from "./ManageOrder.vue?vue&type=template&id=95c5176c&scoped=true"
import script from "./ManageOrder.vue?vue&type=script&lang=js"
export * from "./ManageOrder.vue?vue&type=script&lang=js"
import style0 from "./ManageOrder.vue?vue&type=style&index=0&id=95c5176c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c5176c",
  null
  
)

export default component.exports